module.exports = __webpack_public_path__ + "static/LOGO-BLOG-WANCLOUDS.0b8d4566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Blog/LOGO-BLOG-WANCLOUDS.png
// module id = 207
// module chunks = 107818501498521 212839066777427